module.exports = __webpack_public_path__ + "instagram-icon.jpg?72f5365b00ec580f07ac75626f07b8bd";


//////////////////
// WEBPACK FOOTER
// ./src/images/instagram-icon.jpg
// module id = 58
// module chunks = 0